import { createSlice } from '@reduxjs/toolkit';
import { ProviderCompanyDetailStateType } from 'src/types/providerCompanyDetail';

const initialState: ProviderCompanyDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    error: false,
};
export const providerCompanyDetailSlice = createSlice({
    name: 'providerCompanyDetail',
    initialState,
    reducers: {
        getProviderCompanyDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProviderCompanyDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getProviderCompanyDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createProviderCompanyDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        createProviderCompanyDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createProviderCompanyDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateProviderCompanyDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateProviderCompanyDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateProviderCompanyDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        deleteProviderCompanyFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteProviderCompanyFetchSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteProviderCompanyFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearProviderCompanyDetail: () => initialState,
    },
});

export const {
    getProviderCompanyDetailFetch,
    getProviderCompanyDetailFetchSuccess,
    getProviderCompanyDetailFetchFailure,
    createProviderCompanyDetailFetch,
    createProviderCompanyDetailFetchSuccess,
    createProviderCompanyDetailFetchFailure,
    updateProviderCompanyDetailFetch,
    updateProviderCompanyDetailFetchSuccess,
    updateProviderCompanyDetailFetchFailure,
    deleteProviderCompanyFetch,
    deleteProviderCompanyFetchSuccess,
    deleteProviderCompanyFetchFailure,
    clearProviderCompanyDetail,
} = providerCompanyDetailSlice.actions;

export default providerCompanyDetailSlice.reducer;
